export default function PHP_AccessModifiers() {
  return (
    <div>
      <h1>PHP_AccessModifiers</h1>
    </div>
  );
}
